goog.provide("shadow.js.shim.module$$mui$material$Chip$default");
shadow.js.shim.module$$mui$material$Chip$default = shadow.js.shim.module$$mui$material$Chip.default;
